module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-100 mt-2"
  }, [_c('div', {
    staticClass: "w-100 darker font-weight-600 mb-4 mx-3 fs-large"
  }, [_vm._v("Transport Details")]), _vm._v(" "), _c('div', {
    staticClass: "justify-content-md-center d-flex flex-row"
  }, [_c('button', {
    staticClass: "btn scondary mr-2",
    class: {
      'bg-medium': _vm.reservation.transport.transfers.length !== 1
    },
    attrs: {
      "disabled": _vm.reservation.transport.transfers.length === 0 && _vm.hasTransport
    },
    on: {
      "click": _vm.setAsOneWay
    }
  }, [_vm._v("One way")]), _vm._v(" "), _c('button', {
    staticClass: "btn scondary mr-2",
    class: {
      'bg-medium': _vm.reservation.transport.transfers.length !== 2
    },
    attrs: {
      "disabled": _vm.reservation.transport.transfers.length === 0 && _vm.hasTransport
    },
    on: {
      "click": _vm.setAsRoundTrip
    }
  }, [_vm._v("Round trip")]), _vm._v(" "), (_vm.hasTransport) ? _c('button', {
    staticClass: "btn scondary mr-2",
    class: {
      'bg-medium': _vm.reservation.transport.transfers.length !== 0
    },
    attrs: {
      "disabled": _vm.reservation.transport.transfers.length !== 0
    },
    on: {
      "click": _vm.setAsNoTransport
    }
  }, [_vm._v("No Details")]) : _vm._e(), _vm._v(" "), (!_vm.hasTransport) ? _c('button', {
    staticClass: "btn scondary",
    class: {
      'bg-medium': _vm.reservation.transport.transfers.length !== 0
    },
    attrs: {
      "disabled": _vm.reservation.transport.transfers.length !== 0 && _vm.hasTransport
    },
    on: {
      "click": _vm.setAsNoTransport
    }
  }, [_vm._v("No transportation")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-13 row mx-1 d-flex justify-content-between"
  }, _vm._l((_vm.reservation.transport.transfers), function(transfer, index) {
    return _c('div', {
      staticClass: "col-sm-6 mb-4 mt-4"
    }, [_c('div', {
      staticClass: "bg-lighter py-3"
    }, [_c('div', {
      staticClass: "col-sm-12 dark font-weight-600 justify-content-between d-flex"
    }, [_c('span', [_vm._v("Custom "), _c('toggle-button', {
      attrs: {
        "labels": {
          checked: 'Yes',
          unchecked: 'No'
        },
        "disabled": _vm.readOnly || _vm.reservation.event.eventRoutes.length === 0 || !_vm.routesByType(transfer.transportDirection).length > 0
      },
      on: {
        "change": function($event) {
          return _vm.isCustomChange(transfer)
        }
      },
      model: {
        value: (transfer.isCustom),
        callback: function($$v) {
          _vm.$set(transfer, "isCustom", $$v)
        },
        expression: "transfer.isCustom"
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "dark py-1 px-2"
    }, [_vm._v(_vm._s((transfer.transportDirection == 1) ? 'Pickup' : 'Drop Off'))])]), _vm._v(" "), (transfer.isCustom) ? _c('div', {
      staticClass: "col-sm-12 my-2"
    }, [(_vm.getCompanySettings.settingsPresets) ? _c('span', {
      staticClass: "darker font-weight-600"
    }, [_vm._v("\n                        " + _vm._s(_vm.getCompanySettings.settingsPresets.customRouteNote) + "\n                    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!transfer.isCustom) ? _c('div', [(!_vm.roundTrip) ? _c('div', {
      staticClass: "col-sm-12 mt-3"
    }, [_c('label', [_vm._v("Type")]), _vm._v(" "), _c('div', {
      staticClass: "d-flex"
    }, [_c('radio', {
      staticClass: "mr-4",
      attrs: {
        "name": "transportType",
        "value": 1,
        "disabled": _vm.readOnly
      },
      on: {
        "input": function($event) {
          return _vm.oneWayTypeChanged(transfer)
        }
      },
      model: {
        value: (transfer.transportDirection),
        callback: function($$v) {
          _vm.$set(transfer, "transportDirection", $$v)
        },
        expression: "transfer.transportDirection"
      }
    }, [_vm._v("\n                                Pickup\n                            ")]), _vm._v(" "), _c('radio', {
      attrs: {
        "name": "transportType",
        "value": 2,
        "disabled": _vm.readOnly
      },
      on: {
        "input": function($event) {
          return _vm.oneWayTypeChanged(transfer)
        }
      },
      model: {
        value: (transfer.transportDirection),
        callback: function($$v) {
          _vm.$set(transfer, "transportDirection", $$v)
        },
        expression: "transfer.transportDirection"
      }
    }, [_vm._v("\n                                Drop off\n                            ")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 mt-3"
    }, [_c('div', {
      staticClass: "d-flex flex-row justify-content-between"
    }, [_c('label', [_vm._v("List")]), _vm._v(" "), (transfer.errorRoute) ? _c('span', {
      staticClass: "color-6 fs-small"
    }, [_vm._v("Invalid")]) : _vm._e()]), _vm._v(" "), _c('v-select', {
      attrs: {
        "options": _vm.routesByType(transfer.transportDirection),
        "label": "name",
        "disabled": _vm.readOnly
      },
      on: {
        "input": function($event) {
          return _vm.setExitStop($event, transfer)
        }
      },
      model: {
        value: (transfer.route),
        callback: function($$v) {
          _vm.$set(transfer, "route", $$v)
        },
        expression: "transfer.route"
      }
    })], 1), _vm._v(" "), (transfer.exitStop && transfer.transportDirection == 2) ? _c('div', {
      staticClass: "col-sm-12 mt-3"
    }, [_c('label', [_vm._v("From")]), _vm._v(" "), _c('input', {
      staticClass: "d-block w-100 border-light px-2",
      attrs: {
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": _vm.iteneraryNiceOptions(transfer.route.id).length > 0 ? _vm.iteneraryNiceOptions(transfer.route.id)[0].name : null
      }
    })]) : _vm._e(), _vm._v(" "), (transfer.route && _vm.routes.length > 0) ? _c('div', {
      staticClass: "col-sm-12 mt-3"
    }, [_c('label', [_vm._v(_vm._s((transfer.transportDirection == 1) ? 'From' : 'To'))]), _vm._v(" "), (transfer.errorStop) ? _c('span', {
      staticClass: "color-6 fs-small"
    }, [_vm._v("Invalid")]) : _vm._e(), _vm._v(" "), _c('v-select', {
      attrs: {
        "options": _vm.iteneraryOptions(transfer),
        "label": "name",
        "disabled": _vm.readOnly
      },
      on: {
        "input": function($event) {
          return _vm.setSelectedLocation(transfer)
        }
      },
      model: {
        value: (transfer.stop),
        callback: function($$v) {
          _vm.$set(transfer, "stop", $$v)
        },
        expression: "transfer.stop"
      }
    }), _vm._v(" "), (transfer.stop && transfer.stop.note) ? _c('div', {
      staticClass: "mt-3"
    }, [_c('label', [_vm._v("Note")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(transfer.stop.note))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (transfer.exitStop && transfer.transportDirection == 1) ? _c('div', {
      staticClass: "col-sm-12 mt-3"
    }, [_c('label', [_vm._v("To")]), _vm._v(" "), (_vm.iteneraryNiceOptions(transfer.route.id)[_vm.iteneraryNiceOptions(transfer.route.id).length - 1]) ? _c('input', {
      staticClass: "d-block w-100 border-light px-2",
      attrs: {
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": _vm.iteneraryNiceOptions(transfer.route.id)[_vm.iteneraryNiceOptions(transfer.route.id).length - 1].name
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "d-flex"
    }, [(transfer.stop) ? _c('div', {
      staticClass: "col-sm-6 mt-3"
    }, [_c('label', [_vm._v("Time")]), _vm._v(" "), (transfer.errorSchedule) ? _c('span', {
      staticClass: "color-6 fs-small"
    }, [_vm._v("Invalid")]) : _vm._e(), _vm._v(" "), _c('v-select', {
      staticClass: "w-100",
      attrs: {
        "options": _vm.possibleTimes(transfer),
        "label": "timeShort",
        "disabled": _vm.readOnly
      },
      on: {
        "input": function($event) {
          return _vm.timeChanged(transfer)
        }
      },
      model: {
        value: (transfer.schedule),
        callback: function($$v) {
          _vm.$set(transfer, "schedule", $$v)
        },
        expression: "transfer.schedule"
      }
    })], 1) : _vm._e(), _vm._v(" "), (transfer.schedule) ? _c('div', {
      staticClass: "col-sm-6 mt-3"
    }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('datepicker', {
      attrs: {
        "input-class": "bg-lightest w-100",
        "format": "dd.MM.yyyy"
      },
      on: {
        "input": function($event) {
          return _vm.dateChanged($event, transfer)
        }
      },
      model: {
        value: (transfer.schedule.date),
        callback: function($$v) {
          _vm.$set(transfer.schedule, "date", $$v)
        },
        expression: "transfer.schedule.date"
      }
    })], 1) : _vm._e()]), _vm._v(" "), (transfer.stop && transfer.stop.notes) ? _c('div', {
      staticClass: "col-sm-12 mt-3"
    }, [_c('label', [_vm._v("Info")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(transfer.stop.notes))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (transfer.isCustom) ? _c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-12 mt-3"
    }, [_c('div', {
      staticClass: "d-flex flex-row justify-content-between"
    }, [_c('label', [_vm._v("From")]), _vm._v(" "), (transfer.errorRoute) ? _c('span', {
      staticClass: "color-6 fs-small"
    }, [_vm._v("Invalid")]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (transfer.stop.name),
        expression: "transfer.stop.name"
      }],
      staticClass: "w-100",
      attrs: {
        "type": "text",
        "disabled": _vm.readOnly
      },
      domProps: {
        "value": (transfer.stop.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(transfer.stop, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 mt-3"
    }, [_c('div', {
      staticClass: "d-flex flex-row justify-content-between"
    }, [_c('label', [_vm._v("To")]), _vm._v(" "), (transfer.errorStop) ? _c('span', {
      staticClass: "color-6 fs-small"
    }, [_vm._v("Invalid")]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (transfer.exitStop.name),
        expression: "transfer.exitStop.name"
      }],
      staticClass: "w-100",
      attrs: {
        "type": "text",
        "disabled": _vm.readOnly
      },
      domProps: {
        "value": (transfer.exitStop.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(transfer.exitStop, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6 mt-3"
    }, [_c('div', {
      staticClass: "d-flex flex-row justify-content-between"
    }, [_c('label', [_vm._v("Time")]), _vm._v(" "), (transfer.errorTime) ? _c('span', {
      staticClass: "color-6 fs-small"
    }, [_vm._v("Invalid")]) : _vm._e()]), _vm._v(" "), _c('timepicker', {
      attrs: {
        "defaultTime": _vm.customHour(transfer)
      },
      on: {
        "change": function($event) {
          return _vm.setCustomTime($event, transfer)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6 mt-3"
    }, [_c('div', {
      staticClass: "d-flex flex-row justify-content-between"
    }, [_c('label', [_vm._v("Date")]), _vm._v(" "), (transfer.errorDate) ? _c('span', {
      staticClass: "color-6 fs-small"
    }, [_vm._v("Invalid")]) : _vm._e()]), _vm._v(" "), _c('datepicker', {
      attrs: {
        "input-class": "bg-lightest w-100",
        "format": "dd.MM.yyyy"
      },
      on: {
        "input": function($event) {
          return _vm.customDateChanged($event, transfer)
        }
      },
      model: {
        value: (transfer.schedule.date),
        callback: function($$v) {
          _vm.$set(transfer.schedule, "date", $$v)
        },
        expression: "transfer.schedule.date"
      }
    })], 1)])]) : _vm._e()])])
  }), 0)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-227e3087", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-227e3087"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Resume/AddTransport/RouteForm.vue
// module id = 1705
// module chunks = 0